import { render, staticRenderFns } from "./brandShop.vue?vue&type=template&id=1f5d1356&scoped=true"
import script from "./brandShop.vue?vue&type=script&lang=js"
export * from "./brandShop.vue?vue&type=script&lang=js"
import style0 from "./brandShop.vue?vue&type=style&index=0&id=1f5d1356&prod&lang=scss&scoped=true"
import style1 from "./brandShop.vue?vue&type=style&index=1&id=1f5d1356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d1356",
  null
  
)

export default component.exports